<template>
  <div class="container">
    <div class="columns is-centered">
      <div class="column">
        <div class="content">
          <ValidationObserver
            v-slot="{ errors }"
            tag="div"
          >
            <input-form
              ref="form"
              :errors="errors"
              name="LandlordFileUpload"
              @submit.prevent="handleFileUpload"
            >
              <h1>Eviction Diversion Program Application</h1>
              <h2>Upload Rent Ledger</h2>
              <div>
                <div>For the tenant: {{ TenantFirstName + " " + TenantLastName }}</div>
                <div>At the address: {{ TenantAddress }}</div>
              </div>
              <callout
                type="info"
              >
                <div>
                  <p>You must verify the amount owed by uploading a ledger. (Please note that the fillable ledger option is no longer available).</p>
                  <p><b>Failure to provide a ledger will result in your application being denied. An inaccurate ledger will result in your application being delayed.</b></p>
                  <p><b>The ledger must include the property address, tenant name, and total amount past due.</b> The balance due on the ledger must match the back rent or fees (arrears) amount entered on the application.</p>
                </div>
                <br>
                <div>
                  Acceptable ledger documents include:
                  <p class="faq-line-indent">
                    <ul>
                      <li>A formal ledger from a property management system listing dates and amounts of all charges, payments, and amounts due for rent and fees since the date of move in or last zero balance.</li>
                      <li>
                        A Word document, Excel spreadsheet, or handwritten document listing past due rent and fees with dates and amounts for each individual item. <a
                          target="_blank"
                          :href="$rentLedgerTemplate"
                        >Click here for sample template</a>.
                      </li>
                      <li>A Notice to Quit that lays out each month and fee being charged.</li>
                    </ul>
                  </p>
                  <!-- <ul>
                <li>
                  Proof that <a href="https://dpd-eviction-diversion-documents.s3.amazonaws.com/NOTICE+OF+DIVERSION+RIGHTS+FINAL+3.10.2022.pdf">Notice of Diversion Rights</a> was delivered. Please visit the <a
                    href="https://eviction-diversion.phila.gov/FAQ"
                    target="_blank"
                  >FAQ</a> for acceptable forms of proof.
                </li>
              </ul> -->
                </div><br>

                <div>
                  For landlords receiving rent payments from Philadelphia Housing Authority (PHA), Housing Choice Voucher (HCV) program, etc., only include the rent portion the tenant is responsible for paying. If you are seeking Targeted Financial Assistance (TFA) funding, it will not include rent owed by PHA, HCV, or alternative housing subsidy programs.
                </div>
              </callout>
              <!-- <callout
                type="warning"
              >
                <strong>Failure to upload the required supporting documents will result in your application being denied.</strong>
              </callout> -->
              <!-- <callout
                type="danger"
              >
                <strong>IMPORTANT -- Please follow these steps to upload documents successfully:</strong>
                <ol>
                  <li>Select the file you wish to upload using the blue button below.</li>
                  <li>The "Finish" button will appear in the bottom right corner of this page when documents have been selected for required fields.</li>
                  <li>Once the file has been selected, click the “Submit” button to upload it.</li>
                  <li>Do not hit the back button. Wait for the green message that the document has been uploaded before closing this page.</li>
                </ol>
              </callout> -->
              <div class="field-container file-uploads">
                <h3><b>File Uploads</b></h3>
              </div>
              <!-- <h5>Proof of Delivery Document: <b style="color:red">(required)</b></h5>
          <ul id="upload-list-proof-of-delivery-documents">
            <li
              v-for="file in ProofOfDeliveryDocument"
              :key="file.id"
            >
              <span>{{ file.name }} - </span>
              <span
                v-if="file.error"
                class="is-love-park-red"
              >
                Something went wrong - {{ file.errorMessage }}
              </span>

              <span
                v-else-if="file.success"
                class="is-phanatic-green"
              >
                Upload Successful. Please select another document to upload if you have multiple documents.
              </span>
              <span
                v-else-if="file.uploading"
                class="is-flyers-orange"
              >
                Uploading Document...</span>
            </li>
          </ul>
          <file-upload
            ref="upload"
            v-model="ProofOfDeliveryDocument"
            :input-id="`file-upload-proof-of-delivery-files`"
            extensions="gif,jpg,jpeg,png,webp,pdf"
            accept="image/png,image/gif,image/jpeg,image/webp,application/pdf"
            :size="1024 * 1024 * 4.5"
            @input-filter="inputFilter"
          >
            <button
              class="button is-primary"
              style="margin-bottom: 1%;"
            >
              <i class="fa fa-plus" />
              Select ONE File to Upload
            </button>
          </file-upload><br><br> -->
              <!-- <div class="columns">
                <vee-radio
                  id="ledger-upload-choice"
                  v-model="LedgerUploadChoice"
                  :options="MultipleChoiceFieldOptions.YesNo"
                  label="Do you wish to upload a ledger? Selecting &quot;No&quot; means you will proceed to enter the ledger manually."
                  rules="required"
                  required
                  error="This field is required"
                />
              </div> -->
              <!-- <div
                v-if="LedgerUploadChoice === 'Yes'"
                class="columns"
              >
                <callout type="info">
                  Acceptable forms of ledger for upload
                  <ul>
                    <li>Rent Ledger or detailed list of past due rent and fees. The document must include the property address, tenant name, and total amount past due. The balance due on the ledger must match the arrears amount entered on the application. A ledger is not required if you are not claiming past due rent/fees. Acceptable ledger documents include:</li>
                    <li>A formal ledger from a property management system listing dates and amounts of all charges, payments, and amounts due for rent and fees since the date of move in or last zero balance.</li>
                    <li>
                      A Word document, Excel spreadsheet, or handwritten document listing past due rent and fees with dates and amounts for each individual item. <a
                        target="_blank"
                        :href="$rentLedgeTemplate"
                      >Click here for sample template.</a>
                    </li>
                    <li>A Notice to Quit that lays out each month and fee being charged.</li>
                  </ul>
                </callout>
                <br>
              </div> -->
              <div
                v-if="LedgerUploadChoice === 'Yes'"
                class="columns"
              >
                <callout
                  v-if="(PropertyInfoProvider == false && TFAOptIn == 'Yes')"
                  type="warning"
                >
                  <b>Upload instructions:</b>
                  <ol>
                    <li>Select the file you wish to upload using the blue button below. The file upload accepts images and PDFs, with a maximum file size of 4.5mb.</li>
                    <li>Once the file has been selected, click the 'Next' button to upload it.</li>
                    <li>Do not hit the back button.</li>
                  </ol>
                </callout>
                <callout
                  v-else
                  type="warning"
                >
                  <b>Upload instructions:</b>
                  <ol>
                    <li>Select the file you wish to upload using the blue button below. The file upload accepts images and PDFs, with a maximum file size of 4.5mb.</li>
                    <li>Once the file has been selected, click the 'Submit' button to upload it.</li>
                    <li>Do not hit the back button.</li>
                  </ol>
                </callout>
              </div>
              <div
                v-if="LedgerUploadChoice === 'Yes'"
              >
                <h5>Rent Ledger: <b style="color:red">(required)</b></h5>
                <ul id="upload-list-rent-ledger-documents">
                  <li
                    v-for="file in RentLedger"
                    :key="file.id"
                  >
                    <span>{{ file.name }} - </span>
                    <span
                      v-if="file.error"
                      class="is-love-park-red"
                    >
                      Something went wrong - {{ file.errorMessage }}
                    </span>

                    <span
                      v-else-if="file.success"
                      class="is-phanatic-green"
                    >
                      Upload Successful. Please select another document to upload if you have multiple documents.
                    </span>
                    <span
                      v-else-if="file.uploading"
                      class="is-flyers-orange"
                    >
                      Uploading Document...</span>
                  </li>
                </ul>
                <file-upload
                  ref="upload"
                  v-model="RentLedger"
                  :input-id="`file-upload-ledger-document`"
                  extensions="gif,jpg,jpeg,png,webp,pdf"
                  accept="image/png,image/gif,image/jpeg,image/webp,application/pdf"
                  :size="1024 * 1024 * 4.5"
                  @input-filter="inputFilter"
                >
                  <button class="button is-primary">
                    <i class="fa fa-plus" />
                    &nbsp; Select ONE File to Upload
                  </button>
                </file-upload>
                <br>
                <br>
                <div v-if="Arrears != null">
                  Arrears amount claiming: ${{ Arrears }}
                </div>
                <callout
                  v-if="(PropertyInfoProvider == false && TFAOptIn == 'Yes')"
                  type="danger"
                >
                  *Ensure that the amount listed above is true and accurate. By clicking on 'Next', you are agreeing to the arrears amount owed and waiving any additional amount not listed on the application.
                </callout>
                <callout
                  v-else
                  type="danger"
                >
                  *Ensure that the amount listed above is true and accurate. By clicking on 'Submit', you are agreeing to the arrears amount owed and waiving any additional amount not listed on the application.
                </callout>
                <p v-if="(PropertyInfoProvider == false && TFAOptIn == 'Yes')">
                  <b>Important: Your EDP Application continues on the next page. Once the Rent Ledger is selected, you must click 'Next' to upload it and continue completing your application.</b>
                </p>
                <p v-else>
                  <b>Once the Rent Ledger is selected, you must click 'Submit' to upload it.</b>
                </p>
              </div>
              <br>
              <!-- <h5>Additional Files:</h5>
          <ul id="upload-list-landlord-documents">
            <li
              v-for="file in LandlordFiles"
              :key="file.id"
            >
              <span>{{ file.name }} - </span>
              <span
                v-if="file.error"
                class="is-love-park-red"
              >
                Something went wrong - {{ file.errorMessage }}
              </span>

              <span
                v-else-if="file.success"
                class="is-phanatic-green"
              >
                Upload Successful. Please select another document to upload if you have multiple documents.
              </span>
              <span
                v-else-if="file.uploading"
                class="is-flyers-orange"
              >
                Uploading Document...</span>
            </li>
          </ul>
          <file-upload
            ref="upload"
            v-model="LandlordFiles"
            :input-id="`file-upload-landlord-files`"
            extensions="gif,jpg,jpeg,png,webp,pdf"
            accept="image/png,image/gif,image/jpeg,image/webp,application/pdf"
            :multiple="true"
            :size="1024 * 1024 * 4.5"
            @input-filter="inputFilter"
          >
            <button
              class="button is-primary"
              style="margin-bottom: 1%;"
            >
              <i class="fa fa-plus" />
              Select Files to Upload
            </button>
          </file-upload> -->
              <div
                v-if="(LedgerUploadChoice === 'No')"
                class="actions columns"
              >
                <callout
                  type="danger"
                  style="margin-left:1%"
                >
                  You must complete the fillable ledger on the next page. Please click on the 'Next' button.
                </callout>
              </div>
              <div
                class="actions columns"
              >
                <!--<div class="actions columns">-->

                <!--Required criteria for above div: v-if="(ProofOfDeliveryDocument.length != 0 && RentLedger.length != 0)"-->
                <div
                  v-if="(PropertyInfoProvider == false && TFAOptIn == 'Yes') || LedgerUploadChoice == 'No'"
                  class="column is-2 is-offset-20"
                  style="margin-top:2%"
                >
                  <button
                    class="button is-primary"
                    type="button"
                    :disabled="(LedgerUploadChoice == 'Yes' && RentLedger.length == 0) || LedgerUploadChoice == null"
                    @click="handleFileUpload()"
                  >
                    Next
                  </button><br><br>
                </div>
                <div
                  v-else
                  class="column is-2 is-offset-20"
                  style="margin-top:2%"
                >
                  <button
                    class="button is-primary"
                    type="button"
                    :disabled="(LedgerUploadChoice == 'Yes' && RentLedger.length == 0) || LedgerUploadChoice == null"
                    @click="handleFileUpload()"
                  >
                    Submit
                  </button><br><br>
                </div>
              </div>
              <div class="column">
                <div v-if="SubmitStatus.Value === SubmitStatus.Options.PENDING">
                  Submitting...
                </div>
                <div v-if="SubmitStatus.Value === SubmitStatus.Options.OK">
                  OK
                </div>
                <div v-if="SubmitStatus.Value === SubmitStatus.Options.ERROR">
                  Error
                </div>
              </div>
            </input-form>
          </ValidationObserver>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

import FileUpload from "vue-upload-component";
import options from "@/utilities/options";

import buildLandlordFileDataObject from "@/utilities/data-objects/landlord-file-data-object";
import buildLandlordDataFetchObject from "@/utilities/data-objects/landlord-data-fetch-object";
import {
  dataObjectToXml,
  resizeImage,
  getBase64,
  getPropertyValueOrDefault,
} from "@/utilities/functions";

export default {
  name: "ApplicationFiles",
  components: { FileUpload },
  mixins: [options],
  props: {
    applicantId: { default: null, type: String },
    //largefiler: { default: null, type: String },
  },
  data() {
    return {
      LedgerUploadChoice: "Yes",
      RentLedger: [],
      TenantFirstName: "",
      TenantLastName: "",
      TenantAddress: null,
      Arrears: null,
      RentOrFeesOwed: null,
      TFAOptIn: null,
      LandlordRecordID: null,
      PropertyInfoProvider: null,
      ApplicantPropertyOwner: null,
      TenantAddressStreet1: null,
      OwnerEmail: null,
    };
  },
  created(){
    var vData = this;
    const dataObject = buildLandlordDataFetchObject(vData.applicantId, "EDP_FILE_UPLOAD_DATA_REQUEST");
    const requestObj = {
      table: process.env.VUE_APP_QB_APPLICATION, //Note, pointed to new table
      data: dataObject,
    };
    // Grab relevant information from the Application Table on QuickBase
    axios
      .post(
        "https://djql8jp3sb.execute-api.us-east-1.amazonaws.com/V1/EDP-TFA-login-QuickBase-Request-Proxy-Reads",
        requestObj,
      )
      .then((response) => {
        const responseObject = getPropertyValueOrDefault(
          ["data", "record", "f"],
          response,
        );
        vData.TenantFirstName = getPropertyValueOrDefault(["_text"], responseObject.find(i => i._attributes.id === "6"));
        vData.TenantLastName = getPropertyValueOrDefault(["_text"], responseObject.find(i => i._attributes.id === "7"));
        vData.TenantAddress =  getPropertyValueOrDefault(["_text"], responseObject.find(i => i._attributes.id === "1113"));
        vData.TenantAddressStreet1 =  getPropertyValueOrDefault(["_text"], responseObject.find(i => i._attributes.id === "1114"));
        vData.Arrears = getPropertyValueOrDefault(["_text"], responseObject.find(i => i._attributes.id === "65"));
        vData.RentOrFeesOwed = getPropertyValueOrDefault(["_text"], responseObject.find(i => i._attributes.id === "64"));
        vData.TFAOptIn = getPropertyValueOrDefault(["_text"], responseObject.find(i => i._attributes.id === "73"));
        vData.LandlordRecordID = getPropertyValueOrDefault(["_text"], responseObject.find(i => i._attributes.id === "3"));
        vData.PropertyInfoProvider = getPropertyValueOrDefault(["_text"], responseObject.find(i => i._attributes.id === "1069"));
        vData.ApplicantPropertyOwner = getPropertyValueOrDefault(["_text"], responseObject.find(i => i._attributes.id === "71"));
        vData.OwnerEmail = getPropertyValueOrDefault(["_text"], responseObject.find(i => i._attributes.id === "21"));
      });
  },
  methods: {
    // Filter out malicious files from file upload
    inputFilter(newFile, oldFile, prevent) {
      if (newFile && !oldFile) {
        // Before adding a file
        // Filter system files or hide files
        if (/(\/|^)(Thumbs\.db|desktop\.ini|\..+)$/.test(newFile.name)) {
          return prevent();
        }
        // Filter php html js file
        if (/\.(php5?|html?|jsx?|exe?)$/i.test(newFile.name)) {
          alert("Invalid File Type");
          return prevent();
        }
      }
    },
    // Unpack the file from the file upload input object.
    async getFile(uploadData){
      if (uploadData.length) {
        var vData = this;
        let FileIdx = uploadData.length - 1;
        var fileObj = uploadData[FileIdx];
        fileObj.uploading = true;
        fileObj.error = false;
        fileObj.errorMessage = "";
        let file = fileObj.file;
        if (fileObj.type.match(/image.*/)) {
          file = await resizeImage({ file: file, maxSize: 1920 });
        }
        if(file.type != "application/pdf" && file.type != "image/png" && file.type != "image/jpeg"){
          vData.SubmitStatus.Value = vData.SubmitStatus.Options.ERROR;
          fileObj.error = true;
          fileObj.errorMessage =
              "Wrong file type";
          throw "Wrong File Type";
        }
        if (file.size >= 1024 * 1024 * 4.5) {
          vData.SubmitStatus.Value = vData.SubmitStatus.Options.ERROR;
          fileObj.error = true;
          fileObj.errorMessage =
              "File is too large, please reduce your file's size and try again.";
          throw "File is too large";
        } else {
          return await getBase64(file);
        }
      }
    },
    // Upload the file to QuickBase
    async pushFileToQB(file, fileType){
      let vData = this;
      try{
        if(vData.LandlordRecordID == null || vData.LandlordRecordID == ""){
          vData.SubmitStatus.Value = vData.SubmitStatus.Options.ERROR;
          throw "Landlord Record ID is null";
        }
        var document = await this.getFile(file); // Call getFile() function 
        var documentName= file[0].name;
        const dataObject = await buildLandlordFileDataObject(
          vData.LandlordRecordID,
          documentName,
          document,
          fileType,
          vData.applicantId,
          vData.TenantFirstName + " " + vData.TenantLastName,
          vData.TenantAddressStreet1,
          vData.OwnerEmail,
          0,
          0,
        );
        const xmlDataObject = await dataObjectToXml(dataObject);
        const requestObj = {
          table: process.env.VUE_APP_QB_FILES,
          action: "API_AddRecord",
          data: xmlDataObject,
        };
        // Push file object to QuickBase
        await axios
          .post(
            "https://djql8jp3sb.execute-api.us-east-1.amazonaws.com/V1/Eviction-Diversion-login-QuickBase-Request-Proxy",
            requestObj,
          )
          .then((qbResult) => {
            console.log(qbResult);
            file[0].uploading = false;
            file[0].success = true;
            vData.SubmitStatus.Value = vData.SubmitStatus.Options.OK;
          })
          .catch(() => {
            vData.SubmitStatus.Value = vData.SubmitStatus.Options.ERROR;
            file[0].errorMessage =
                "File is too large, please reduce your file's size and try again.";
          });
      } catch(err){
        vData.SubmitStatus.Value = vData.SubmitStatus.Options.ERROR;
        throw err;
      }
    },
    async handleFileUpload() {
      var vData = this;
      vData.SubmitStatus.Value = vData.SubmitStatus.Options.PENDING;
      
      const isInputValid = await vData.$refs.form.$parent.validate();
      if (isInputValid) {
        try{

          // If a ledger is not bring uploaded goto the Manual Ledger Page
          if(vData.LedgerUploadChoice == "No"){
            vData.$router.push({
              name: "Ledger",
              params: { applicantId: vData.applicantId },
            });
          } else if(vData.LedgerUploadChoice == "Yes"){

            // Upload Ledger
            await this.pushFileToQB(this.RentLedger, "Ledger");

            if (!vData.RentLedger.some(i => i.uploading)){
              // If the following conditions are met Goto the Bank Information collection Page
              if(vData.RentOrFeesOwed == 'Yes' && vData.Arrears <= 3500 && vData.TFAOptIn == 'Yes' && vData.PropertyInfoProvider == false){
                vData.$router.push({
                  name: "DetailedApplication",
                  params: { applicantId: vData.applicantId },
                });
              } else{
                // If the previous conditions are not met goto the Landlord Success page
                vData.$router.push({
                  name: "LandlordSuccessPage",
                  params: { applicantId: vData.applicantId },
                });
        
              }
            }
          }
        } catch(err){
          vData.SubmitStatus.Value = vData.SubmitStatus.Options.ERROR;
        }
      } else{
        vData.SubmitStatus.Value = vData.SubmitStatus.Options.ERROR;
      }
    },
  },
};
</script>

<style scoped>
.is-flyers-orange {
  color: hsl(35, 100%, 49%);
}
.is-phanatic-green {
  color: hsl(121.6, 38.6%, 37.1%);
}
.is-love-park-red {
  color: hsl(14.1, 100%, 40%);
}
</style>
